import { base64Encode } from 'app/utils/string';

export const dataUrl = (mime, charset = null, text) => {
  const contents = base64Encode(text);
  if (charset) {
    return `data:${mime};charset=${charset};base64,${contents}`;
  } else {
    return `data:${mime};base64,${contents}`;
  }
};

export const svgDataUrl = dataUrl.bind(null, 'image/svg+xml', 'utf-8');
